module.exports = __webpack_public_path__ + "media/assets/images/sales-processes-clients-0d2d333e0c3f64831ec05f75222f90d6.svg";